// import Test from './testing/Test'
import { Navigate, Route, Routes } from 'react-router-dom'
import Header from './components/Header/Header'
import BuyQr from './pages/Qr/BuyQr'
import QrTicket from './pages/Qr/QrTicket'
import QrTickets from './pages/Qr/QrTickets'
import Support from './pages/Support/Support'
import TranRoutes from './pages/TranRoutes/TranRoutes'
import './utils/init'
import classNames from 'classnames'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ResetOfflineToastOnRouteChange } from './components/Routes/ResetOfflineToastOnRouteChange'
import LoadingModal from './components/reusable/Modals/LoadingModal'
import AppToastContainer from './components/reusable/Notifications/AppToastContainer'
import { a11ySelector } from './redux/slices/a11y'

function App() {
  const { a11yColorScheme, fontSize, letterSpacing } = useSelector(a11ySelector)

  useEffect(() => {
    // Set styles for the html element
    document.documentElement.style.fontSize = `${fontSize}px`
    document.documentElement.style.letterSpacing = `${letterSpacing}px`
  }, [fontSize, letterSpacing])

  return (
    <div
      className={classNames('App', a11yColorScheme)}
      // style={{ fontSize: `${fontSize}px`, letterSpacing: `${letterSpacing}px` }}
    >
      {/* <Test /> */}
      <Header />

      <Routes>
        <Route index element={<Navigate to="/tran_routes" />} />
        <Route path="/tran_routes" element={<TranRoutes />} />
        <Route path="/qr">
          <Route index element={<BuyQr />} />
          <Route path="tickets">
            <Route index element={<QrTickets />} />
            <Route path=":ticket_id" element={<QrTicket />} />
          </Route>
        </Route>
        <Route path="/support" element={<Support />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      <AppToastContainer />
      <ResetOfflineToastOnRouteChange />
      <LoadingModal />
    </div>
  )
}

export default App
